// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__lK9iU","tab":"ProcedureTabs_tab__3hYhs"};